import { Link } from '@uhg-abyss/web/ui/Link';
import React from 'react';

import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { ChipState } from '../../../../store/useChipStore/chipStore';
import { ConstantsRoutes } from '../../../ConstantsRoutes';
import { convertObjectToUrlParams } from '../../../Utils';
import { findAllMatches } from '../../../Utils/findAllMatches/findAllMatches';
import {
  ProviderSpeciality,
  physicianLinkStyles,
  physicianNameStyles,
} from '../PhysicianDirectory.styled';

type Props = {
  physician: {
    providerId?: string | undefined;
    providerName?: string;
    specialities: string;
  };
  linkOnClick: (a: any) => void;
  search: string;
  chipStore: ChipState;
};

export const DirectoryLink = ({
  physician,
  linkOnClick,
  search,
  chipStore,
}: Props) => {
  const name = physician.providerName?.replace(/,\s*$/, '');
  const specialitiesValid = physician.specialities
    ? physician.specialities.match('.*[a-zA-Z]+.*')
    : false;
  const [enableRightClickMenu, removeTruncation] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_RIGHT_CLICK_MENU,
    ConstantsLagoon.FEATURE_FLAGS.REMOVE_TRUNCATION_DATACARD,
  ]);
  const params = {
    providerId: physician.providerId,
  };
  const urlParams = convertObjectToUrlParams(chipStore, params);
  const url = enableRightClickMenu
    ? `/findcare${ConstantsRoutes.PROVIDER_DETAILS.path}${urlParams}`
    : '';

  return (
    <Link
      css={physicianLinkStyles(removeTruncation)}
      data-auto-testid="physician-link"
      data-testid="physician-link"
      href={url}
      isStandardAnchor
      key={physician.providerId}
      onClick={(e) => {
        e.preventDefault();
        linkOnClick(physician);
      }}
    >
      <div style={physicianNameStyles(removeTruncation)}>
        {search.length > 0
          ? findAllMatches(search, name).map((x) =>
              x.isMatch ? <mark key={name}>{x.text}</mark> : x.text
            )
          : name}
      </div>

      {specialitiesValid ? (
        <ProviderSpeciality>{physician.specialities}</ProviderSpeciality>
      ) : null}
    </Link>
  );
};
